const utils = require("frontend-controller/lib/utils");
module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'projectTerms',
        showHead: true,
        showIDs: true,
        // showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {
            statusFlagsSummary: true,
        },
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '105px',
        },
        rowActions: {
            edit: true,
            customs: [
                // {
                //     buttonType: 'showLocation',
                // },
                {
                    privilegeCode: 'bo_projectTerms:delete',
                    buttonType: 'delete',
                    neutral: true,
                }
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_status': true,
            'resourceChanged.bo_projectTerms': true,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'timeRange',
                direction: 'asc'
            },{
                fieldCode: 'projectTermID',
                direction: 'asc'
            }]
        }
    },

    methods: {
        onPrepareDone(){
            if(this.config.usage === 'selection') {
                this.config.rowActions = {}
            } else {
                this.config.customHeadActionsFormMapping = {
                    buttons: [
                        { buttonType: 'moveToProject', context: this.config.buttonContext, icon: 'fi fi-move', privilegeCode: 'bo_projectTerms:update', },
                        { buttonType: 'showInsert', context: this.config.buttonContext, positive: true, privilegeCode: 'bo_projectTerms:create', },
                    ]
                }
            }
        },

        onSubmitDone(callerComponent, entityID, entityData, insertPerformed){
            switch(((callerComponent || {}).config || {}).entityContext){
                case 'projectTerms':
                    const myProjectID = ((this.model.parentEntityForTable || {}).baseFilters || {}).projectID
                    const foundProjectID = ((entityData || {}).attributes || {}).projectID

                    if(myProjectID && foundProjectID && myProjectID == foundProjectID){
                        if(insertPerformed && entityID && entityData){
                            this.showEdit(entityID, entityData)
                        }
                    }
                    break;
            }
        },

        async moveToProject(buttonContext, buttonMode, decisionOrigin = {}){
            const projectID = ((this.model.parentEntityForTable || {}).baseFilters || {}).projectID

            if (projectID) {

                if(buttonMode === 'selectProject'){
                    const baseActionKey = 'showSelect_project'
                    await this.performAndStoreAction(
                        `${baseActionKey}_inEffect`,
                        this.prepareAction(baseActionKey, undefined, {
                            decisionOrigin: {
                                ...(decisionOrigin || {}),
                            },
                        }),
                        true
                    )
                } else {
                    const baseActionKey = 'showSelect_projectTerms'
                    await this.performAndStoreAction(
                        `${baseActionKey}_inEffect`,
                        this.prepareAction(baseActionKey, undefined, {
                            decisionOrigin: {
                                ...(decisionOrigin || {}),
                                type: 'moveToProject',
                                step: 'selectProjectTerms',
                                buttonContext,
                                buttonMode,
                                sourceProjectID: projectID
                            },
                        }),
                        true
                    )
                }
            } else {
                // TODO: MESSAGE?
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey
            const myProjectID = ((this.model.parentEntityForTable || {}).baseFilters || {}).projectID

            if(refreshers[key] && (
                (
                    key !== 'resourceChanged.bo_projectTerms' &&
                    key !== 'resourceChanged.bo_status'
                ) ||
                (key === 'resourceChanged.bo_projectTerms' && (
                    message.data.projectID == myProjectID ||
                    (message.data.projectIDs || {})[myProjectID]
                )) ||
                (key === 'resourceChanged.bo_status' && this.isAtLeastOneStatusIDLoaded(message.data.statusIDs))
            )){
                this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
            }

            // close all moved projectTerm-tabs
            if((message.data.movedProjectTermsByProjectID || {})[myProjectID]){
                this.locate('< templates_office_projectTerms_controller < templates_core_tabStrip_tabStrip', tabStrip => {
                    for(const projectTermID in (message.data.movedProjectTermsByProjectID || {})[myProjectID]){
                        tabStrip.closeTabsByEntity('projectTerms', projectTermID)
                    }
                })
            }
        },
    },

    hooks: {
        async onDecision($element, options){
            let hideModalComponent = false

            let modalContentComponent
            if(options.decisionComponent.hasClass('base_modal_modal')) {
                hideModalComponent = options.decisionComponent
                modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component
            }

            switch(options.decisionType){
                case 'submit':
                    const decisionOptions = (options || {}).decisionOptions || {}
                    const decisionOrigin = (options || {}).decisionOrigin || {}

                    if(decisionOrigin.type === 'moveToProject'){
                        if(decisionOrigin.step === 'selectProjectTerms'){
                            let projectTermsSelectionTable
                            if(modalContentComponent){
                                modalContentComponent.find('templates_office_projectTerms_table', table => {
                                    projectTermsSelectionTable = table
                                })
                            }

                            if(projectTermsSelectionTable){
                                const projectTermsData = projectTermsSelectionTable.getSelectedRows(true) || {}
                                const projectTermIDs = {}
                                const shippingOrderPresenceProjectTermIDs = {}
                                for(const termKey in projectTermsData){
                                    const projectTerm = projectTermsData[termKey] || {}
                                    const attributes = projectTerm.attributes || {}
                                    const projectTermID = attributes[projectTerm.primaryKey || 'id'] || 0
                                    if(projectTermID){
                                        projectTermIDs[projectTermID] = true
                                        if(attributes.shippingOrderID){
                                            shippingOrderPresenceProjectTermIDs[projectTermID] = true
                                        }
                                    }
                                }

                                if(utils.collectionSize(shippingOrderPresenceProjectTermIDs) > 0){
                                    return this.performAction(
                                        this.prepareAction('message', undefined, {
                                            messageDisplay: {
                                                message: 'error:projects.projectTerms.notAbleToMoveProjectTermsToAnotherProjectInCaseOfShippingOrderPresence',
                                                variables: {
                                                    projectTermIDs: Object.keys(shippingOrderPresenceProjectTermIDs).join(', ')
                                                }
                                            }
                                        }, {
                                            statusControllerLoadingMessage: '',
                                            statusControllerSavingMessage:  ''
                                        })
                                    )
                                }

                                if(utils.collectionSize(projectTermIDs) <= 0){
                                    return this.performAction(
                                        this.prepareAction('message', undefined, {
                                            messageDisplay: {
                                                message: 'error:projects.projectTerms.notAbleToMoveNoProjectTermsToAnotherProject'
                                            }
                                        }, {
                                            statusControllerLoadingMessage: '',
                                            statusControllerSavingMessage:  ''
                                        })
                                    )
                                }

                                await this.moveToProject('projectTerms', 'selectProject', {
                                    ...decisionOrigin,
                                    step: 'selectProject',
                                    projectTermIDs
                                })

                            } else {
                                console.error('projectTermsSelectionTable not found')
                            }
                        } else if(decisionOrigin.step === 'selectProject'){
                            const sourceProjectID = decisionOrigin.sourceProjectID
                            const targetProjectID = decisionOptions.entityID || 0
                            const projectTermIDs = decisionOrigin.projectTermIDs

                            if(options.decisionComponent){
                                options.decisionComponent.closest('base_modal_modal', m => hideModalComponent = m)
                            }

                            if(sourceProjectID && targetProjectID && utils.collectionSize(projectTermIDs) > 0){

                                if(sourceProjectID == targetProjectID){
                                    return this.performAction(
                                        this.prepareAction('message', undefined, {
                                            messageDisplay: {
                                                message: 'error:projects.projectTerms.notAbleToMoveProjectTermsToTheVerySameProject'
                                            }
                                        }, {
                                            statusControllerLoadingMessage: '',
                                            statusControllerSavingMessage:  ''
                                        })
                                    )
                                }

                                const data = Object.keys(projectTermIDs).map(projectTermID => ({
                                    attributes: {
                                        projectTermID,
                                        projectID: targetProjectID,
                                    }
                                }))

                                // NOTE: hide modal before projectTerms getting patched to avoid unwanted re-open of selectProject-modal via refresher.
                                await hideModalComponent.hide()
                                hideModalComponent = null

                                await this.performAction(
                                    this.prepareAction('edit_projectTerms', undefined, undefined, {
                                        source: {
                                            submit: {
                                                data: {
                                                    data,
                                                    meta: {
                                                        sourceProjectID,
                                                        targetProjectID,
                                                    }
                                                }
                                            }
                                        }
                                    }),
                                )
                            }
                        }
                    }

                    // hide modal
                    if(hideModalComponent){
                        await hideModalComponent.hide()
                    }
                    break;

                case 'cancel':
                default:
                    // hide modal
                    if(hideModalComponent){
                        await hideModalComponent.hide()
                    }
                    break;
            }
        },
    },
}